import { useQuery } from '@tanstack/react-query';
import { getTRSRegistrations } from '@/API/TRSRegistration/getTRSRegistrations';

const useGetTRSRegistrations = (setTableData, colDefs, registrarID) => {
    return useQuery({
        queryKey: ['TRSRegistrations', registrarID],
        queryFn: async () => {
            if (!registrarID) return [];

            try {
                const response = await getTRSRegistrations(registrarID);
                const data = response.data || [];

                // Update table data when query succeeds
                if (setTableData) {
                    setTableData({
                        columns: colDefs,
                        data: data,
                    });
                }

                return data;
            } catch (error) {
                console.error('Error fetching TRS registrations:', error);

                // Clear table data on error
                if (setTableData) {
                    setTableData({
                        columns: colDefs,
                        data: [],
                    });
                }

                throw error;
            }
        },
        enabled: !!registrarID,
        staleTime: 0,
        cacheTime: 0,
        refetchOnWindowFocus: false,
    });
};

export default useGetTRSRegistrations;
